'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var types = require('./types.js');
var R = require('ramda');
var Websockets = require('@rushplay/websockets');

var initialState = [];
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case Websockets.SESSION_EXPIRED:
    case types.CLEARED:
      {
        return initialState;
      }

    case types.REMOVED:
      {
        var triggerIndex = R.findIndex(R.propEq('id', action.payload), state);
        return R.remove(triggerIndex, 1, state);
      }

    case types.UPDATED:
      {
        return R.unionWith(R.eqBy(R.prop('id')), action.payload, state);
      }

    default:
      {
        return state;
      }
  }
}

exports.reducer = reducer;
//# sourceMappingURL=reducer.js.map
